export default __webpack_public_path__ + "static/media/clock.e080ed5e.png";